import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Button } from '../../../../shared/components/button/button';
import { DevelopmentProjectsService } from '../../../../shared/services/development.projects.service';
import { IDevelopmentProject } from '../../../../shared/interfaces/development-project.interface';
import { CalendlyService } from '../../../../shared/services/calendly.service';
import { Observable } from 'rxjs';

const CALENDLY_URL = 'https://calendly.com/mikekordvani/30min?hide_gdpr_banner=1&background_color=0d0420&text_color=ffffff&primary_color=7c3aed';

@Component({
  selector: 'app-development-projects',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './development-projects.html',
  styleUrls: ['./development-projects.scss']
})
export class DevelopmentProjects implements OnInit {
  projects$!: Observable<IDevelopmentProject[]>;

  constructor(
    private router: Router,
    private devProjectsService: DevelopmentProjectsService,
    private calendly: CalendlyService,
  ) {}

  ngOnInit(): void {
    this.projects$ = this.devProjectsService.getProjects();
  }

  navigateTo(name: string) {
    this.router.navigate([`case-studies/${name.toLowerCase()}/`]);
  }

  scheduleCall() {
    this.calendly.openPopup(CALENDLY_URL).catch(() => {});
  }
}
